import { render, staticRenderFns } from "./setmealGoodsSet.vue?vue&type=template&id=83120832&scoped=true&"
import script from "./setmealGoodsSet.vue?vue&type=script&lang=js&"
export * from "./setmealGoodsSet.vue?vue&type=script&lang=js&"
import style0 from "./setmealGoodsSet.vue?vue&type=style&index=0&id=83120832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83120832",
  null
  
)

export default component.exports